/* eslint-disable import/no-cycle */
import { isCCCNA, isPackageTypeNotEqualsToBulk } from './common';
import * as types from './constants';
import { formatNumberBasedOnTheLocale } from './formatUtils';

const calculatePallets = cartItems =>
  cartItems.map(item => item.fullPalletOrdering && item.palletSelected).reduce((acc, item) => acc + item);

// when not bulk and fullPalletOrdering is set to false, then the product is considered to be less than full pallet.
const ltfpNetWeight = (item, netWeightOrNetWeightPerUnit = '') => {
  const { packageType, fullPalletOrdering, quantity, itemNetWeight } = item;
  return isPackageTypeNotEqualsToBulk(packageType) && !fullPalletOrdering
    ? quantity * netWeightOrNetWeightPerUnit
    : itemNetWeight;
};

// when not bulk and fullPalletOrdering is set to false, then the product is considered to be less than full pallet.
const ltfpGrossWeight = item => {
  const { packageType, fullPalletOrdering, quantity, netWeightPerUnit, itemNetWeight, grossWeight } = item;
  return isPackageTypeNotEqualsToBulk(packageType) && !fullPalletOrdering
    ? quantity * netWeightPerUnit * grossWeight
    : itemNetWeight * grossWeight;
};

// when not bulk and fullPalletOrdering is set to false, then the product is considered to be less than full pallet.
const ltfpQuantity = item => {
  const { packageType, fullPalletOrdering, quantity, itemNetWeight } = item;
  return isPackageTypeNotEqualsToBulk(packageType) && !fullPalletOrdering ? quantity : itemNetWeight;
};

const calculateNetWeight = (cartItems, brSalesArea, showPallet = true) =>
  cartItems
    .map(item => {
      const { netWeightPerUnit, netWeight, packageType, fullPalletOrdering, palletSelected, perPalletcount } = item;
      let weight = netWeightPerUnit;
      if (brSalesArea) {
        weight = netWeight;
      }
      // when not bulk and fullPalletOrdering is set to false, then the product is considered to be less than full pallet.
      return isPackageTypeNotEqualsToBulk(packageType) && fullPalletOrdering && showPallet
        ? palletSelected * perPalletcount * weight
        : ltfpNetWeight(item, weight);
    })
    .reduce((acc, item) => acc + item);

const calculateGrossWeight = cartItems =>
  cartItems
    .map(item => {
      const { packageType, fullPalletOrdering, palletSelected, perPalletcount, netWeightPerUnit, grossWeight } = item;
      // when not bulk and fullPalletOrdering is set to false, then the product is considered to be less than full pallet.
      return isPackageTypeNotEqualsToBulk(packageType) && fullPalletOrdering
        ? palletSelected * perPalletcount * netWeightPerUnit * grossWeight
        : ltfpGrossWeight(item);
    })
    .reduce((acc, item) => acc + item);

/**
 * @param {string | number} originalWeight
 * @param  {string} unitOfMeasure
 * @param {string} salesArea
 * @param {number} decimalMap [defaultValue=2]
 * @method convertKGtoLBBasedOnSalesArea
 * @description Utility to convert a value in KG to LB based on a specific sales area
 */
const convertKGtoLBBasedOnSalesArea = (
  originalWeight,
  unitOfMeasure,
  salesArea,
  decimalMap = 2,
  fromContracts = true
) => {
  if (originalWeight && unitOfMeasure === types.KG && isCCCNA(salesArea)) {
    const weightToNumber = Number(originalWeight);
    if (!Number.isNaN(weightToNumber)) {
      const weightConverted = weightToNumber * types.CONVERSION_UNIT_TO_LB;
      const shouldRoundToANearestInteger = fromContracts ? Math.round(weightConverted) : weightConverted;
      return `${formatNumberBasedOnTheLocale(shouldRoundToANearestInteger.toString(), decimalMap)}`;
    }
  }
  return `${formatNumberBasedOnTheLocale(originalWeight.toString(), decimalMap)}`;
};

export {
  calculateGrossWeight,
  calculateNetWeight,
  calculatePallets,
  convertKGtoLBBasedOnSalesArea,
  ltfpGrossWeight,
  ltfpNetWeight,
  ltfpQuantity
};
